import { render, staticRenderFns } from "./DotListItem.vue?vue&type=template&id=d518fe74&scoped=true&"
import script from "./DotListItem.vue?vue&type=script&lang=ts&"
export * from "./DotListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DotListItem.vue?vue&type=style&index=0&id=d518fe74&scoped=true&lang=scss&"
import style1 from "./DotListItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518fe74",
  null
  
)

export default component.exports